
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { mapGetters } from 'vuex'

import { MARKETPLACES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import { COOKIES_TRACKING_NAME } from '../../constants'

import translations from './CookiesModal.translations'

export default {
  components: {
    RevButton,
    RevLink,
    RevIllustration,
    FormattedMessage,
  },

  props: {
    marketplace: {
      type: String,
      required: true,
    },
    zone: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      windowHeight: 0,
    }
  },

  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    translations: () => translations,
    ROUTES: () => ROUTES,
    displayRefuseAllButton() {
      return this.marketplace !== MARKETPLACES.NA
    },
    cookieImage() {
      return this.$static('/img/gdpr/cookie.png')
    },
  },

  mounted() {
    this.windowHeight = window.innerHeight
  },

  methods: {
    handleClickAccept() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.ACCEPT })
      this.$emit('accept')
    },
    handleClickRefuse() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.REFUSE })
      this.$emit('refuse')
    },
    handleClickParams() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.SETTINGS })
      this.$emit('params')
    },
    handleClickCookiesTerms() {
      trackClick({ zone: this.zone, name: COOKIES_TRACKING_NAME.INFO })
    },
    handleClickLegalMentions() {
      trackClick({
        zone: this.zone,
        name: COOKIES_TRACKING_NAME.LEGAL_MENTIONS,
      })
    },
    handleClickDataProtection() {
      trackClick({
        zone: this.zone,
        name: COOKIES_TRACKING_NAME.DATA_PROTECTION,
      })
    },
  },
}
